import React, { useState, useEffect } from 'react';
import { X, ChevronDown, ChevronUp } from 'lucide-react';
import { StyledHamburgerMenu, StyledHamburgerIcon, StyledMenuItems } from './styled';
import { ROUTE_PATH } from '../../constants/routePath';
import { Link } from "react-router-dom";
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBagShopping } from '@fortawesome/free-solid-svg-icons';

const StyledNavLink = styled(Link)`
  font-weight: 600;
  font-size: 16px;
  padding: 8px 16px;
  cursor: pointer!important;
  color: white;
  display: flex;
  margin-bottom: 10px;
  height: 52px;
  align-items: center;
  text-decoration: none;
  border-radius: 4px;
  transition: all 0.3s ease;

  &.login {
    color: #ffe955;
    background-color: transparent;

    &:hover {
      background-color: rgba(255, 233, 85, 0.1);
    }
  }
  &.signup {
    background-color: #ffe955;
    color: #000000;

    &:hover {
      background-color: #FFC000;
    }
  }
  &.cart {
    background-color: transparent;
    color: #ffffff;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }
  }

  .a {
    color: white!important;
    cursor: pointer!important;
  }
`;

const HamburgerMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDiscoverOpen, setIsDiscoverOpen] = useState(false);
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [isProductsOpen, setIsProductsOpen] = useState(false);
  // Close menu when cart is opened from anywhere
  useEffect(() => {
    const handleCartOpen = () => {
      setIsOpen(false);
    };

    const handleCloseMenu = () => {
      setIsOpen(false);
    };

    window.addEventListener('openCart', handleCartOpen);
    window.addEventListener('closeHamburgerMenu', handleCloseMenu);
    
    return () => {
      window.removeEventListener('openCart', handleCartOpen);
      window.removeEventListener('closeHamburgerMenu', handleCloseMenu);
    };
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const toggleDiscover = () => {
    setIsDiscoverOpen(!isDiscoverOpen);
  };
  const toggleCreate = () => {
    setIsCreateOpen(!isCreateOpen);
  };
  const toggleProducts = () => {
    setIsProductsOpen(!isProductsOpen);
  };

  const handleSignUp = () => {
    window.location.href = `https://admin.sparkle.store${ROUTE_PATH.REGISTER}`;
  };  const handleLoginUp = () => {
    // Check if we're on a shop URL
    if (window.location.pathname.includes('/shop')) {
      // Navigate to customer login
      window.location.href = '/customer/login';
    } else {
      // Original behavior for other pages
      window.location.href = `https://admin.sparkle.store${ROUTE_PATH.MYSTORE}`;
    }
  };

  const isOnShopUrl = () => {
    return window.location.pathname.includes('/shop');
  };

  const handleInstagram = () => {
    window.location.href = `${ROUTE_PATH.INSTAGRAM}`;
  };

  const handleTwitter = () => {
    window.location.href = `${ROUTE_PATH.TWITTER}`;
  };

  const handleTikTok = () => {
    window.location.href = `${ROUTE_PATH.TIKTOK}`;
  };

  const handleCustomTShirts = () => {
    window.location.href = `${ROUTE_PATH.TSHIRT}`;
  };  const handleCustomProducts = () => {
    window.location.href = `${ROUTE_PATH.CUSTOMPRODUCTS}`;
  };

  // Product category handlers
  const handleAllProducts = () => {
    window.location.href = '/custom-products';
  };

  const handleSpecialOffers = () => {
    window.location.href = '/custom-products';
  };

  const handleEmbroideryProducts = () => {
    window.location.href = '/custom-products';
  };

  const handleFastDelivery = () => {
    window.location.href = '/custom-products';
  };

  const handleNewProducts = () => {
    window.location.href = '/custom-products';
  };

  const handleBestsellers = () => {
    window.location.href = '/custom-products';
  };

  const handleEcoFriendly = () => {
    window.location.href = '/custom-products';
  };

  const handleMensClothing = () => {
    window.location.href = '/custom-products';
  };

  const handleWomensClothing = () => {
    window.location.href = '/custom-products';
  };

  const handleKidsClothing = () => {
    window.location.href = '/custom-products';
  };

  const handleHomeLiving = () => {
    window.location.href = '/custom-products';
  };

  const handleHats = () => {
    window.location.href = '/custom-products';
  };

  const handleViewAllProducts = () => {
    window.location.href = '/custom-products';
  };

  const isActive = (path) => {
    if (path === ROUTE_PATH.HOME) {
      return window.location.pathname === path;
    }
    return window.location.pathname.startsWith(path);
  };

  const isDiscoverActive = () => {
    return ['/creator/link-in-bio-for-instagram', '/creator/link-in-bio-for-tiktok', '/creator/link-in-bio-for-twitter'].some(path =>
      window.location.pathname.startsWith(path)
    );
  }; const isCreateActive = () => {
    // Add logic to determine when Create should be active
    return ['/create/t-shirts', '/custom-products', '/custom/', ROUTE_PATH.DESIGNS].some(path =>
      window.location.pathname.startsWith(path)
    );
  };

  const isShopActive = () => {
    return window.location.pathname.startsWith('/shop');
  };

  const isProductsActive = () => {
    return ['/all-products', '/special-offers', '/embroidery-products', '/fast-delivery',
      '/new-products', '/bestsellers', '/eco-friendly', '/mens-clothing', '/womens-clothing',
      '/kids-youth-clothing', '/home-living', '/hats', '/view-all-products'].some(path =>
        window.location.pathname.startsWith(path)
      );
  };

  return (
    <>
      <StyledHamburgerIcon onClick={toggleMenu}>
        {isOpen ? <X size={24} /> : '☰'}
      </StyledHamburgerIcon>
      <StyledHamburgerMenu isOpen={isOpen}>
        {isOpen && (
          <StyledMenuItems>
            <div>
              <StyledNavLink
                onClick={toggleProducts}
                style={{
                  color: isProductsActive() ? '#ffe955' : 'white',
                  fontSize: '1.30rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                Products
                {isProductsOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
              </StyledNavLink>
              {isProductsOpen && (
                <div style={{ marginLeft: '1rem' }}>
                  <StyledNavLink onClick={handleAllProducts} style={{ fontSize: '1.25rem' }}>
                    All products
                  </StyledNavLink>
                  <StyledNavLink onClick={handleSpecialOffers} style={{ fontSize: '1.25rem' }}>
                    Special offers
                  </StyledNavLink>
                  <StyledNavLink onClick={handleEmbroideryProducts} style={{ fontSize: '1.25rem' }}>
                    Embroidery products
                  </StyledNavLink>
                  <StyledNavLink onClick={handleFastDelivery} style={{ fontSize: '1.25rem' }}>
                    Fast delivery
                  </StyledNavLink>
                  <StyledNavLink onClick={handleNewProducts} style={{ fontSize: '1.25rem' }}>
                    New products
                  </StyledNavLink>
                  <StyledNavLink onClick={handleBestsellers} style={{ fontSize: '1.25rem' }}>
                    Bestsellers
                  </StyledNavLink>
                  <StyledNavLink onClick={handleEcoFriendly} style={{ fontSize: '1.25rem' }}>
                    Eco-friendly
                  </StyledNavLink>
                  <StyledNavLink onClick={handleMensClothing} style={{ fontSize: '1.25rem' }}>
                    Men&apos;s clothing
                  </StyledNavLink>
                  <StyledNavLink onClick={handleWomensClothing} style={{ fontSize: '1.25rem' }}>
                    Women&apos;s clothing
                  </StyledNavLink>
                  <StyledNavLink onClick={handleKidsClothing} style={{ fontSize: '1.25rem' }}>
                    Kids & youth clothing
                  </StyledNavLink>
                  <StyledNavLink onClick={handleHomeLiving} style={{ fontSize: '1.25rem' }}>
                    Home & living
                  </StyledNavLink>
                  <StyledNavLink onClick={handleHats} style={{ fontSize: '1.25rem' }}>
                    Hats
                  </StyledNavLink>
                  <StyledNavLink onClick={handleViewAllProducts} style={{ fontSize: '1.25rem' }}>
                    View all products
                  </StyledNavLink>
                </div>
              )}            </div>
            <StyledNavLink
              style={{
                color: isShopActive() ? '#ffe955' : 'white',
                fontSize: '1.30rem',
              }}
              onClick={() => window.location.href = '/shop'}
            >
              Shop
            </StyledNavLink>
            <StyledNavLink
              style={{
                color: isActive(ROUTE_PATH.TOOLS) ? '#ffe955' : 'white',
                fontSize: '1.30rem',
              }}
              to={ROUTE_PATH.TOOLS}
            >
              Tools
            </StyledNavLink>
            <div>
              <StyledNavLink
                onClick={toggleDiscover}
                style={{
                  color: isDiscoverActive() ? '#ffe955' : 'white',
                  fontSize: '1.30rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                Discover
                {isDiscoverOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
              </StyledNavLink>
              {isDiscoverOpen && (
                <div style={{ marginLeft: '1rem' }}>
                  <StyledNavLink onClick={handleInstagram} style={{ fontSize: '1.25rem' }}>
                    Sparkle for Instagram
                  </StyledNavLink>
                  <StyledNavLink onClick={handleTikTok} style={{ fontSize: '1.25rem' }}>
                    Sparkle for TikTok
                  </StyledNavLink>
                  <StyledNavLink onClick={handleTwitter} style={{ fontSize: '1.25rem' }}>
                    Sparkle for Twitter
                  </StyledNavLink>
                </div>
              )}
            </div>
            <div>
              <StyledNavLink
                onClick={toggleCreate}
                style={{
                  color: isCreateActive() ? '#ffe955' : 'white',
                  fontSize: '1.30rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                Create
                {isCreateOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
              </StyledNavLink>              {isCreateOpen && (
                <div style={{ marginLeft: '1rem' }}>
                  <StyledNavLink onClick={handleCustomProducts} style={{ fontSize: '1.25rem' }}>
                    Custom Products
                  </StyledNavLink>
                  <StyledNavLink
                    style={{
                      fontSize: '1.25rem',
                      color: isActive(ROUTE_PATH.DESIGNS) ? '#ffe955' : 'white'
                    }}
                    to={ROUTE_PATH.DESIGNS}
                  >
                    Design Library
                  </StyledNavLink>
                  <StyledNavLink onClick={handleCustomTShirts} style={{ fontSize: '1.25rem' }}>
                    Custom T-Shirts
                  </StyledNavLink>
                </div>
              )}
            </div>            <div style={{ marginTop: 'auto' }}>
              <StyledNavLink onClick={handleLoginUp} className="login">
                Login
              </StyledNavLink>
              
              {isOnShopUrl() && (
                <StyledNavLink 
                  onClick={() => {
                    // Close the menu first
                    setIsOpen(false);
                    // Then trigger cart toggle
                    window.dispatchEvent(new CustomEvent('toggleCart'));
                  }}
                  className="cart"
                  style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                >
                  <FontAwesomeIcon icon={faBagShopping} />
                  Cart
                </StyledNavLink>
              )}
              
              {!isOnShopUrl() && (
                <StyledNavLink onClick={handleSignUp} className="signup">
                  Sign up free
                </StyledNavLink>
              )}
            </div>
          </StyledMenuItems>
        )}
      </StyledHamburgerMenu>
    </>
  );
};

export default HamburgerMenu;